import React, { useEffect, useRef, useState } from 'react';
import { useTenancy } from '@/contexts/TenancyContext';
import { db } from '@/js/external-js/config/main_config';

import {
  Accordion,
  AccordionItem,
  AccordionTrigger,
  AccordionContent,
} from '@/components/ui/accordion';
import { Badge } from "@/components/ui/badge"
import { Separator } from "@/components/ui/separator"

import EditableField from '@/components/ui/EditableField';
import { FrameworkBadge } from '@/app/pages/msg/components/FrameworkBadge';

import {
  getStandardName,
  fetchRelatedDocuments,
  populateStandardsList,
  populateCustomContent,
  fetchPageContent,
  getAllModules, fetchPageContentMDX
} from '@/app/pages/msg/utils/common';
import { MarkdownRenderer } from '@/app/pages/msg/components/MarkdownRenderer';
import { useMarkdownComponents } from '@/app/pages/msg/components/MDXFields';
import { Toggle } from '@/components/ui/toggle';
import { RelatedClausesAccordianItem } from '@/app/pages/msg/components/RelatedClauses';
import SupportingDocs from '@/app/pages/msg/components/SupportingDocs';
import FootNote from '../components/FootNote';
import AdditionalContent from '../components/AdditionalContent';
import SupportingDocsDropdown from '../components/SupportingDocsDropdown';


export default function OverviewSection() {
  const { activeTenancy } = useTenancy();

  // MDX Things
  const [pageTemplateMDX, setPageTemplateMDX] = React.useState<string>('');
  const [modulesList, setModulesList] = useState([]);
  const clauseStandards = useRef<Set<string>>(new Set());
  const [pageClauses, setPageClauses] = useState<Set<string>>(new Set());
  
  // Function to update pageClauses
  const updatePageClauses = (newClauses: Set<string>) => {
    setPageClauses(new Set(newClauses));
  };

  const [pageTemplate, setPageTemplate] = React.useState<string>('');
  // const [supportingDocs, setSupportingDocs] = React.useState([]);
  const [dynamicContent, setDynamicContent] = React.useState<string>("");

  const pageName = 'general';
  const contentPath = ['overview'];
  const pageRoute = '/MSG/general/overview';

  useEffect(() => {
    if (activeTenancy.id == "") return;

    const loadModules = async () => {
      const allModules = await getAllModules();
      const storedVisibilities = JSON.parse(localStorage.getItem('modulesVisibility') || '{}');

      allModules.forEach(module => {
        module.visible = storedVisibilities[module.id] ?? false;
      });

      setModulesList(allModules);
    }

    fetchPageContentMDX(db, pageName, 'overview_MDX', activeTenancy, setPageTemplateMDX);

    // const getRelatedDocuments = fetchRelatedDocuments(db, activeTenancy.id, pageRoute, setSupportingDocs);

    // New function to populate the contents from the customer
    const getCustomContent = populateCustomContent(db, activeTenancy.id, pageRoute, setDynamicContent);


    const load = async () => {
    }; load();
    loadModules();

    return () => {
      // React upon unloading will cleanup any open websockets
      getCustomContent();
      // getRelatedDocuments();
    };
  }, [activeTenancy]);


  return (
    <div className="space-y-6">
      <div className="bg-card rounded-xl border border-border shadow-sm px-6 py-6 relative">
        <div className="absolute right-4 top-4 z-10">
          <div className="flex items-center space-x-2">
            <SupportingDocsDropdown pageRoute={pageRoute} clauseStandards={clauseStandards} pageClauses={pageClauses} />
            <RelatedClausesAccordianItem modulesList={modulesList} clauseStandards={clauseStandards} setModulesList={setModulesList} />
          </div>
        </div>
        <div className="px-6 py-6">
        <MarkdownRenderer 
          source={pageTemplateMDX} 
          components={useMarkdownComponents(modulesList, clauseStandards, { current: pageClauses }, updatePageClauses)} 
        />
        </div>
        <div style={{maxWidth: '56rem', marginLeft: 'auto', marginRight: 'auto', padding: '0px 1rem 1.5rem', transition: 'color 0.2s, background-color 0.2s', backgroundColor: 'transparent'}}>
          <AdditionalContent pageRoute={pageRoute} />
          <FootNote />
        </div>
      </div>
      {/* <div className='bg-card rounded-xl border border-border shadow-sm'>
        <SupportingDocs pageRoute={pageRoute} clauseStandards={clauseStandards} pageClauses={pageClauses} />
      </div> */}
    </div>
  );
};
